import React from 'react'
import styled from 'styled-components'
import { BodyBold01 } from '~/components/common/typography'

import commonCss from '~/core/css'
import { translate } from '~/core/translate'

export const TextContainer = styled(BodyBold01)`
  ${commonCss.textEllipsis};
  display: inline-block;
  vertical-align: middle;
`

const ParticipantName = ({ isSelf, participant }) => (
  <TextContainer>
    {isSelf
      ? `${participant.name} (${translate(
          'me'
        ).toLowerCase()})`
      : participant.name}
  </TextContainer>
)

export default ParticipantName
